var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("EditModal", {
    attrs: {
      open: _vm.open,
      saveButtonLabel: _vm.$t("livechat.reassignChat.reassignBtn"),
      maxWidth: "800px",
      loading: _vm.addLoading,
    },
    on: { save: _vm.onSave, cancel: _vm.onCancel },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _vm._v(
              " " +
                _vm._s(_vm.$t("livechat.reassignChat.availableAgents")) +
                " "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "subtitle",
        fn: function () {
          return [
            _c("v-text-field", {
              attrs: {
                "append-icon": "mdi-magnify",
                label: _vm.$t("livechat.reassignChat.searchAgents"),
                "single-line": "",
                "hide-details": "",
              },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.availableAgents,
                search: _vm.filter,
                "item-key": "email",
                "show-select": "",
                "single-select": "",
                loading: _vm.loading,
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function ({ item }) {
                    return [
                      _c("ProfileAvatar", {
                        attrs: {
                          small: "",
                          profilePicture: item.profilePicture,
                        },
                      }),
                      _c("span", { staticClass: "ml-2 mr-2" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c("StatusDot", {
                        attrs: { active: item.status === "online" },
                      }),
                    ]
                  },
                },
                {
                  key: "item.groups",
                  fn: function ({ item }) {
                    return _vm._l(item.groups, function (group, index) {
                      return _c("v-chip", { key: index }, [
                        _vm._v(" " + _vm._s(_vm.getGroupName(group)) + " "),
                      ])
                    })
                  },
                },
              ]),
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }